<template>
  <modal
    name="date-select"
    height="100%"
    scrollable
    style="z-index: 1050; display: flex; align-items: flex-start; justify-content: center; height: 100%"
  >
    <div class="modal-search-date">
      <DateSelectFields
        ref="fields"
        v-bind="$props"
        @updateValue="(checkIn, checkOut) => $emit('updateValue', checkIn, checkOut)"
        @completed="$modal.hide('date-select')"
      />
      <div class="modal-fixbottom">
        <button class="modal-clearbtn" @click.prevent="$refs.fields.clearSelection()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#adadad"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="inline-block mb-1"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
          選択をクリア
        </button>
      </div>
    </div>
    <button type="button" class="modal-closebtn" @click="$modal.hide('date-select')"></button>
  </modal>
</template>

<script>
import DateSelectFields from './DateSelectFields.vue'

export default {
  components: {
    DateSelectFields,
  },
  // Same props as DateSelectFields; declared here so v-bind="$props" forwards them.
  props: DateSelectFields.props,
}
</script>
